import { applyMiddleware, legacy_createStore as createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { reducer } from './reducers/index';

const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });

export default createStore(reducer, composeEnhancers(applyMiddleware(thunk)));
